/**
 * Wrapper lazy do LocationMap: mantém o mapbox-gl (~1.8MB) num chunk separado,
 * carregado só quando uma tela realmente mostra o mapa (card do local, detalhe
 * do contrato). Use SEMPRE este em vez de importar LocationMap direto.
 */
import { lazy, Suspense } from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { LEAF_RADIUS } from '../../styles/theme'
import type { LocationMapProps } from './LocationMap'

const LocationMap = lazy(() => import('./LocationMap').then((m) => ({ default: m.LocationMap })))

export function LocationMapLazy(props: LocationMapProps) {
  const height = props.height ?? 280
  const radius = (props.rounded ?? true) ? LEAF_RADIUS : 0
  return (
    <Suspense
      fallback={
        <Box
          sx={{
            height,
            width: '100%',
            borderRadius: radius,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
            border: '1px solid',
            borderColor: 'divider',
          }}
        >
          <CircularProgress size={24} />
        </Box>
      }
    >
      <LocationMap {...props} />
    </Suspense>
  )
}
